import React from 'react'
import PropTypes from 'prop-types'

import { Views } from './Views'
import { AstuteProvider } from './context'

const AstuteCredentials = (props) => {
  return (
    <AstuteProvider {...props}>
      <div id="astute-credentials" className='preferences'>
        <Views />
      </div>
    </AstuteProvider>
  )
}

AstuteCredentials.propTypes = {
  astuteCredentials: PropTypes.object,
}

export default AstuteCredentials
